module.exports = __webpack_public_path__ + "e7e8b73b134889bb9f1174e37c73e988.svg";